import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import NewsList from './components/NewsList';
import { NEWS_ARTICLES } from '@/mocks/news';

export default function NewsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'META66资讯中心 | 元宇宙·6G·Web5.0·XR前沿动态';

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://meta66.cn';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${siteUrl}/news#webpage`,
        url: `${siteUrl}/news`,
        name: 'META66资讯中心 | 元宇宙·6G·Web5.0·XR前沿动态',
        description: '聚焦元宇宙、6G/10G超连接、Web3.0-Web5.0、XR沉浸体验、数字经济、AI智能体、量子科技前沿动态，洞见数字文明未来。',
        inLanguage: 'zh-CN',
        dateModified: '2026-04-03',
        isPartOf: { '@id': `${siteUrl}/#website` },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: '资讯中心', item: `${siteUrl}/news` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'META66元宇宙资讯中心',
        url: `${siteUrl}/news`,
        description: '汇聚元宇宙、6G、Web5.0、XR沉浸体验最新资讯与深度分析，每日更新，覆盖8大技术方向。',
        mainEntity: {
          '@type': 'ItemList',
          name: '元宇宙资讯文章列表',
          numberOfItems: NEWS_ARTICLES.length,
          itemListElement: NEWS_ARTICLES.slice(0, 10).map((article, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            url: `${siteUrl}/news/${article.id}`,
            name: article.title,
          })),
        },
      },
    ];

    const existingScript = document.getElementById('schema-news-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-news-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-news-jsonld');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#020810]" style={{ fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <Navbar />

      {/* Page Header */}
      <section className="relative pt-28 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e032cafc49e0f77fbeaae83d96a43f14.jpg"
            alt="资讯中心背景"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#020810]/60 via-[#020810]/40 to-[#020810]" />
        </div>
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(rgba(0,255,136,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,136,0.03) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-10">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-white/30 text-sm mb-8">
            <Link to="/" className="hover:text-[#00FF88] transition-colors whitespace-nowrap">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/60 whitespace-nowrap">资讯中心</span>
          </div>

          <div className="flex items-center gap-3 mb-4">
            <div className="flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#00FF88]/30 bg-[#00FF88]/5">
              <span className="w-2 h-2 rounded-full bg-[#00FF88] animate-pulse" />
              <span className="text-[#00FF88] text-xs font-semibold tracking-widest uppercase">Meta News</span>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            元宇宙<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00FF88] to-[#00FFCC]"> 资讯中心</span>
          </h1>
          <p className="text-white/40 text-base max-w-2xl leading-relaxed">
            聚焦元宇宙、6G/10G超连接、Web3.0-Web5.0、XR沉浸体验、数字经济、AI智能体、量子科技前沿动态，洞见数字文明未来
          </p>

          {/* Stats Bar */}
          <div className="flex items-center gap-8 mt-8 flex-wrap">
            {[
              { label: '原创文章', value: '1,200+' },
              { label: '月活读者', value: '320万' },
              { label: '覆盖领域', value: '8大方向' },
              { label: '更新频率', value: '每日更新' },
            ].map((s) => (
              <div key={s.label} className="flex flex-col gap-0.5">
                <span className="text-[#00FF88] font-black text-xl" style={{ fontFamily: 'Orbitron, sans-serif' }}>{s.value}</span>
                <span className="text-white/30 text-xs">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News List */}
      <NewsList />

      <Footer />
    </div>
  );
}
